import { render } from "./SectionDescription.vue?vue&type=template&id=141a4e12"
import script from "./SectionDescription.vue?vue&type=script&lang=js"
export * from "./SectionDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__